// 日语
export default {
  Login: {
    Title: "アカウントにログイン",
    describe: "ログインするか、アカウントを作成して開始してください。",
    Google: "Googleで続行",
    Apple: "Appleで続行",
    or: "または",
    Emailplaceholder: "メールアドレス",
    Passwordplaceholder: "パスワード",
    Login: "ログイン",
    forgot: "パスワードをお忘れですか？",
    notAccount: "Fineshareアカウントをお持ちでないですか？",
    Signup: "サインアップ",
    InvalidEmail: "無効なメール形式です。",
    InvalidPassword: "パスワードは6文字以上である必要があります。",
    loading: "読み込み中...",
    login: "ログイン",
    errorText:
      "ログインに失敗しました。ユーザー名とパスワードを確認してください。",
  },
  signup: {
    Title: "アカウントを作成",
    describe: "数秒でFineshareアカウントを作成します。",
    Google: "Googleでサインアップ",
    Apple: "Appleでサインアップ",
    or: "または",
    Emailplaceholder: "メールアドレスを入力",
    Passwordplaceholder: "6桁のパスワードを入力",
    Already: "すでにアカウントをお持ちですか？",
    Login: "ログイン",
    By: "アカウントを作成することで、私は以下に同意したことになります",
    Privacy: "プライバシーポリシー",
    Terms: "利用規約",
    and: "および",
    signupText: "アカウントを作成",
    InvalidEmail: "無効なメール形式です。",
    InvalidPassword: "パスワードは6文字以上である必要があります。",
    loading: "読み込み中...",
    passwordError: "このメールアドレスはすでに登録されています",
    again: "リクエストが多すぎます。後でもう一度お試しください。",
    Registration:
      "登録に失敗しました。メールアドレスとパスワードを確認してください。",
    hasRegistered: "このメールアドレスはすでに登録されています",
  },
  Home: {
    Welcome: "Fineshareアカウントセンターへようこそ",
  },
};
